<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    />
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="$store.state.auth.settings.autoOrgID ? headersNoID : headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 210"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-options': [10, 20, 40, 60, 80, 100],
      }"
      :search="search"
      fixed-header
      must-sort
      :loading="loaderStatus"
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td v-if="!$store.state.auth.settings.autoOrgID" style="max-width: 120px; overflow: hidden; white-space: nowrap">
            {{ item.orgID }}
          </td>
          <td>{{ item.surname }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.areaName }}</td>
          <td>{{ item.department }}</td>
          <td>{{ item.position }}</td>
          <td>{{ item.phone }}</td>
          <td>
            <v-icon :color="item.loginName ? 'green' : 'red'">{{ item.loginName ? mdiCheckBold : mdiCloseThick }}</v-icon>
          </td>

          <td
            v-if="$store.state.auth.userSettings.accEmployees.update"
            class="px-2 tableSelectCursor"
            @click="((dialogEdit = true), (employee = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accEmployees.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accEmployees.export" block color="colorExport" href="/api/v1/export/employees">
          {{ $t('btn.export') }}
          <v-icon>{{ mdiExport }}</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accEmployees.import" block color="colorImport" @click="modalImport = true">
          {{ $t('btn.import') }}
          <v-icon>{{ mdiImport }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="dialogEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.employee') }}
          <v-spacer />
          <v-icon large @click="dialogEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="employeeForm">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.name')"
                  v-model="employee.name"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                  v-on:blur="employee.name = employee.name.charAt(0).toUpperCase() + employee.name.slice(1)"
                  autofocus
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.surname')"
                  v-model="employee.surname"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                  v-on:blur="employee.surname = employee.surname.charAt(0).toUpperCase() + employee.surname.slice(1)"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="!$store.state.auth.settings.autoOrgID" cols="4">
                <v-text-field
                  :label="$tc('label.employeeIdentifier', 2)"
                  v-model="employee.orgID"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                  @click:append-outer="genOrgID"
                  :append-outer-icon="mdiStar"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$tc('label.department', 2)"
                  v-model="employee.department"
                  maxlength="64"
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.position')"
                  v-model="employee.position"
                  maxlength="64"
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.email')"
                  v-model="employee.email"
                  maxlength="64"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiEmail"
                  v-on:blur="employee.email = employee.email.toLowerCase()"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.phone')"
                  v-model="employee.phone"
                  maxlength="64"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiPhoneClassic"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.mobile')"
                  v-model="employee.mobile"
                  maxlength="64"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiPhone"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.floor')"
                  v-model="employee.floor"
                  maxlength="64"
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.door')"
                  v-model="employee.door"
                  maxlength="64"
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model.number="employee.area"
                  :label="$tc('label.area')"
                  :items="listAreas"
                  item-text="name"
                  item-value="id"
                  :return-object="false"
                  :rules="[ruleRequired]"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiHomeCity"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                />
              </v-col>
            </v-row>
            <v-row v-if="$store.state.auth.settings.planVisits">
              <v-col cols="4">
                <v-select
                  v-model.number="employee.employeeGroup"
                  :label="$tc('label.planningGroup')"
                  :items="listEmployeeGroups"
                  item-text="displayName"
                  item-value="id"
                  :menu-props="{ minWidth: '500' }"
                  :return-object="false"
                  append-icon="$dropdown"
                  clearable
                  hide-details
                  dense
                  :prepend-inner-icon="mdiAccountMultipleCheck"
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                  :disabled="!$store.state.auth.userSettings.accEmployees.planningUpdate"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('label.loginName')"
                  v-model="employee.loginName"
                  maxlength="128"
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                  :name="Math.random()"
                  :prepend-inner-icon="mdiFormTextbox"
                  :disabled="!$store.state.auth.userSettings.accEmployees.planningUpdate"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  type="password"
                  :label="$t('label.password')"
                  v-model="employee.password"
                  maxlength="64"
                  hide-details
                  dense
                  autocomplete="new-password"
                  :name="Math.random()"
                  :prepend-inner-icon="mdiFormTextboxPassword"
                  :disabled="!$store.state.auth.userSettings.accEmployees.planningUpdate"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="employee.formatDate"
                  :items="listDateFormats"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.formatDate')"
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="employee.formatTime"
                  :items="listTimeFormats"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.formatTime')"
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="employee.firstDay"
                  :items="listFirstDayOfWeek"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.firstDayOfWeek')"
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="employee.language"
                  :items="listLanguages"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.language')"
                  hide-details
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="employee.note"
                  name="input-7-1"
                  :label="$t('label.note')"
                  no-resize
                  hide-details
                  dense
                  :autocomplete="Math.random()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn v-if="employee.id && $store.state.auth.userSettings.accEmployees.delete" color="colorDelete" @click="modalDelete = true">
            {{ $t('btn.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalImport" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.import') }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="importEvent"
                :label="$t('label.action')"
                :items="listImportEvents"
                hide-details
                append-icon
                auto-select-first
              />
            </v-col>
            <v-spacer />
            <v-col cols="2">
              <v-progress-circular v-if="importProgressStatus" :size="40" color="green" indeterminate />
            </v-col>
            <v-col cols="3">
              <v-btn block color="colorImport" class="mt-2">
                <label for="appLogFileInput">{{ $t('btn.csvFile') }}</label>
                <input
                  id="appLogFileInput"
                  v-on:change="((importFile = $event.target.files), (importFileName = $event.target.files[0].name))"
                  type="file"
                  hidden
                />
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h3>{{ importFileName }}</h3>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn tile color="colorImport" @click="dataImport">{{ $t('btn.import') }}</v-btn>
          <v-spacer />
          <v-btn tile color="colorClose" @click="modalImport = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${employee.name}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import {
  mdiMagnify,
  mdiPen,
  mdiClose,
  mdiHomeCity,
  mdiAccountMultipleCheck,
  mdiStar,
  mdiEmail,
  mdiPhone,
  mdiPhoneClassic,
  mdiExport,
  mdiImport,
  mdiCloseThick,
  mdiCheckBold,
  mdiFormTextbox,
  mdiFormTextboxPassword,
} from '@mdi/js';

export default Vue.extend({
  name: 'SettingsEmployees',
  components: { DialogConfirmDelete },
  data: () => ({
    dialogEdit: false,
    modalDelete: false,
    modalImport: false,
    validForm: false,
    listEmployeeGroups: [],
    listAreas: [],
    listLanguages: [],
    listDateFormats: [
      { text: '21.12.2021', value: 'DD.MM.YYYY' },
      { text: '21/12/2021', value: 'DD/MM/YYYY' },
      { text: '21-12-2021', value: 'DD-MM-YYYY' },
      { text: '2021-12-21', value: 'YYYY-MM-DD' },
      { text: '2021/12/21', value: 'YYYY/MM/DD' },
    ],
    listTimeFormats: [
      { text: '16:23', value: 'HH:mm' },
      { text: '04:23pm', value: 'hh:mmA' },
    ],
    tableData: [],
    loaderStatus: false,
    search: '',
    employee: {
      id: 0,
      orgID: '',
      name: '',
      surname: '',
      loginName: '',
      password: '',
      department: '',
      position: '',
      floor: '',
      door: '',
      note: '',
      email: '',
      phone: '',
      mobile: '',
      employeeGroup: 0,
      area: 0,
      language: '',
      formatDate: '',
      formatTime: '',
      firstDay: 0,
    },
    importFile: '',
    importFileName: '',
    importProgressStatus: false,
    importEvent: 'append',
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiHomeCity: mdiHomeCity,
    mdiAccountMultipleCheck: mdiAccountMultipleCheck,
    mdiStar: mdiStar,
    mdiEmail: mdiEmail,
    mdiPhone: mdiPhone,
    mdiPhoneClassic: mdiPhoneClassic,
    mdiExport: mdiExport,
    mdiImport: mdiImport,
    mdiCloseThick: mdiCloseThick,
    mdiCheckBold: mdiCheckBold,
    mdiFormTextbox: mdiFormTextbox,
    mdiFormTextboxPassword: mdiFormTextboxPassword,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    headers: function () {
      return [
        { text: this.$i18n.t('colTran.text.employee.orgID'), value: 'orgID', width: '120px' },
        { text: this.$i18n.t('colTran.text.surname'), value: 'surname' },
        { text: this.$i18n.t('colTran.text.name'), value: 'name' },
        { text: this.$i18n.t('colTran.text.area.name'), value: 'areaName' },
        { text: this.$i18n.t('colTran.text.employee.department'), value: 'department' },
        { text: this.$i18n.t('colTran.text.employee.position'), value: 'position' },
        { text: this.$i18n.t('colTran.text.employee.phone'), value: 'phone' },
        { text: this.$i18n.t('colTran.text.login'), value: 'loginName' },
        { sortable: false, width: '48px' },
      ];
    },
    headersNoID: function () {
      return [
        { text: this.$i18n.t('colTran.text.surname'), value: 'surname' },
        { text: this.$i18n.t('colTran.text.name'), value: 'name' },
        { text: this.$i18n.t('colTran.text.area.name'), value: 'areaName' },
        { text: this.$i18n.t('colTran.text.employee.department'), value: 'department' },
        { text: this.$i18n.t('colTran.text.employee.position'), value: 'position' },
        { text: this.$i18n.t('colTran.text.employee.phone'), value: 'phone' },
        { text: this.$i18n.t('colTran.text.login'), value: 'loginName' },
        { sortable: false, width: '48px' },
      ];
    },
    listImportEvents: function () {
      return [
        { text: this.$i18n.t('label.append'), value: 'append' },
        { text: this.$i18n.t('label.rewrite'), value: 'rewrite' },
      ];
    },
    listFirstDayOfWeek: function () {
      return [
        { text: this.$i18n.t('label.sunday'), value: 0 },
        { text: this.$i18n.t('label.monday'), value: 1 },
      ];
    },
  },
  watch: {},
  mounted() {
    this.listAreasLoad();
    this.listLanguagesLoad();
    this.listEmployeeGroupsLoad();
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      this.loaderStatus = true;
      axios
        .get('/api/v1/employee')
        .then((response) => {
          this.tableData = response.data;
          this.loaderStatus = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.loaderStatus = false;
        });
    },
    dataNew() {
      const defaults: any = this.$options;
      this.employee = { ...defaults.data().employee };
      if (this.listAreas.length === 1) {
        // Pokud je jen jedna area, nastav jako default pro novy
        this.employee.area = this.listAreas[0].id;
      }
      this.dialogEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.employeeForm;
        form.validate();
      });
      axios
        .get('/api/v1/settings')
        .then((response) => {
          this.employee.formatDate = response.data.formatDate;
          this.employee.formatTime = response.data.formatTime;
          this.employee.firstDay = response.data.firstDay;
          this.employee.language = response.data.language;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      const form: any = this.$refs.employeeForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        if (this.employee.id === 0) {
          axios
            .post('/api/v1/employee', this.employee)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
              } else if (response.data.status === 'loginExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.loginExists'));
              } else {
                this.dataLoad();
                this.dialogEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        } else {
          axios
            .put('/api/v1/employee', this.employee)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.identifierExists'));
              } else if (response.data.status === 'loginExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.loginExists'));
              } else {
                this.dataLoad();
                this.dialogEdit = false;
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/employee/${this.employee.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          if (err.response.status === 409 && err.response.data.message === 'employeeHasPlannedVisits') {
            this.$store.commit('globalMessage', this.$i18n.t('msg.employeeHasPlannedVisits'));
            return;
          }
          this.$store.dispatch('catchErrHandler', err);
        });
      this.dialogEdit = false;
      this.modalDelete = false;
    },
    dataImport() {
      if (this.importFileName === '') {
        this.$store.commit('globalMessage', this.$i18n.t('msg.selectImportFile'));
        return;
      }
      this.importProgressStatus = true;
      const formData = new FormData();
      formData.append('upload', this.importFile[0]);
      axios
        .post(`/api/v1/import/employees/${this.importEvent}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.importProgressStatus = false;
          this.dataLoad();
          this.modalImport = false;
        })
        .catch((err) => {
          this.importProgressStatus = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listLanguagesLoad() {
      axios
        .get('/api/v1/languages')
        .then((response) => {
          this.listLanguages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listEmployeeGroupsLoad() {
      axios
        .get('/api/v1/employeegroup')
        .then((response) => {
          const global = response.data // Zmaz globalni skupinu pro planovani
            .map((item: any) => {
              return item.id;
            })
            .indexOf(0);
          response.data.splice(global, 1);
          this.listEmployeeGroups = response.data;
          for (const row of this.listEmployeeGroups) {
            row.displayName =
              row.name +
              ' (Plánování: ' +
              (row.planners.length > 0 ? 'Ano' : 'Ne') +
              ', Schvalování: ' +
              (row.authorisers.length > 0 ? 'Ano' : 'Ne') +
              ')';
          }
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listAreasLoad() {
      axios
        .get('/api/v1/areabyuser')
        .then((response) => {
          this.listAreas = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    genOrgID() {
      this.employee.orgID =
        (this.employee.surname.substring(0, 3) + this.employee.name.substring(0, 3)).normalize('NFD').replace(/[\u0300-\u036f]/g, '') +
        Math.floor(1000 + Math.random() * 9000);
    },
  },
});
</script>
